import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import ProfilePageContainer, {
  profileUrl as getProfileUrl,
} from "components/ProfilePageLayout";
import ProfilePageAbout from "components/ProfilePageLayout/ProfilePageAbout";
import {
  profileCountriesUrl as getProfileCountriesUrl,
  profileEntitiesUrl as getProfileEntitiesUrl,
  profileSectorsUrl as getProfileSectorsUrl,
  profileVerticalsUrl as getProfileVerticalsUrl,
} from "components/ProfilePageLayout/ProfilePageAbout/ProfilePageStatistics";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const ProfileMoreTabPage: NextPageWithLayout = () => {
  return <ProfilePageAbout />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const profileUrl = getProfileUrl(slug);

    const profileCountriesUrl = getProfileSectorsUrl(slug);
    const profileEntitiesUrl = getProfileVerticalsUrl(slug);
    const profileSectorsUrl = getProfileEntitiesUrl(slug);
    const profileVerticalsUrl = getProfileCountriesUrl(slug);

    const [
      profile,
      profileCountries,
      profileEntities,
      profileSectors,
      profileVerticals,
    ] = await Promise.all([
      baseFetcher(profileUrl, context),
      isSsr(context)
        ? baseFetcher(profileCountriesUrl, context)
        : Promise.resolve(null),
      isSsr(context)
        ? baseFetcher(profileEntitiesUrl, context)
        : Promise.resolve(null),
      isSsr(context)
        ? baseFetcher(profileSectorsUrl, context)
        : Promise.resolve(null),
      isSsr(context)
        ? baseFetcher(profileVerticalsUrl, context)
        : Promise.resolve(null),
    ]);

    if (!profile || profile.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        fallback: {
          [profileUrl]: profile,
          [profileCountriesUrl]: profileCountries,
          [profileEntitiesUrl]: profileEntities,
          [profileSectorsUrl]: profileSectors,
          [profileVerticalsUrl]: profileVerticals,
        },
      },
    };
  } catch (error: any) {
    console.error("[slug].tsx ~ getServerSideProps ~ error", error);
    Bugsnag.notify(error);

    return { notFound: true };
  }
}

ProfileMoreTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <ProfilePageContainer {...pageProps}>{page}</ProfilePageContainer>
    </SWRConfig>
  );
};

export default ProfileMoreTabPage;
